export default __webpack_public_path__ + "03a453ff9f5da43bb0154faa27ee9f33.png";